<div class="form-group row" #formGroupRef>
    <label *ngIf="label" class="col-sm-8 control-label capitalize-first-letter">
        {{ label }}<span *ngIf="ngRequired">*</span>
    </label>
    <div [ngClass]="{'col-sm-40' : label, 'col-sm-48': !label }">
        <div class="form-check form-check-inline" *ngFor="let radio of options">
            <input
                [value]="radio[returnValue]"
                [attr.data-test]="'radio-' + (radio.name | e2eAttributeEncoding)"
                [(ngModel)]="value"
                type="radio"
                [name]="'radio-' + (name | monRemoveWhiteSpace)"
                [attr.id]="radio.name | monRemoveWhiteSpace"
                class="form-check-input"
                (change)="onRadioChange(radio[returnValue])"
                (focusout)="onRadioFocusOut()"
            />
            <label class="form-check-label font-weight-400" [attr.for]="radio.name | monRemoveWhiteSpace">
                {{ radio.name }}
            </label>
        </div>
        <span class="form-text text-secondary-4 text-muted">{{ helpTxt }}</span>
    </div>
</div>
